import React, { useCallback, useMemo } from 'react'
import { ChatContextSourceType } from '@trustero/trustero-api-web/lib/chatcontext/chatcontext_pb'
import { ChatContext } from 'src/components/Reusable/ChatContext/useChatContext.hooks'
import { useAuditsPermalink } from 'src/components/PageLayout/Permalink/generatePermalink'
import { ChatContextBooleanSelector } from '../chatContextPanel.components'
import { ExternalLink } from './utils.components'

export type AuditsModalProps = {
  show: boolean
  hide: () => void
  onBack?: () => void
  context: ChatContext
  setContext: (context: ChatContext) => void
}

export const AuditsModal = ({
  show,
  hide,
  onBack,
  context,
  setContext,
}: AuditsModalProps): JSX.Element => {
  const auditsPermalink = useAuditsPermalink()

  const onCommit = useCallback(
    (includeAll: boolean) => {
      setContext({
        ...context,
        [ChatContextSourceType.AUDIT]: {
          ...context[ChatContextSourceType.AUDIT],
          includeAll,
        },
      })
    },
    [context, setContext],
  )

  const description = useMemo(
    () => (
      <p>
        Select if you want to consider your{' '}
        <ExternalLink to={auditsPermalink}>audits</ExternalLink>
      </p>
    ),
    [auditsPermalink],
  )

  return (
    <ChatContextBooleanSelector
      title="Audits"
      description={description}
      prompt="Do consider audits"
      currentSelection={context[ChatContextSourceType.AUDIT].includeAll}
      onCommit={onCommit}
      show={show}
      hide={hide}
      onBack={onBack}
    />
  )
}
